import { Dialog, DialogContent } from "@material-ui/core";
import React from "react";
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { FormChangeRol } from "../formChangeRol"




export const ModalChangeRol = ({ setopenMondal, isOpen, reload, id }) => {

    const clearData = () => {
        setopenMondal(false)
        reload()
    }


    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%", height: 300 }}
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }} >
                        Cambiar Rol
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px', textAlign: "center" }}>
                        <FormChangeRol close={clearData} id={id} />
                    </DialogContent>

                </Dialog>
            </div>
        </>
    );
}